import { ActionTypes } from "../ActionType";

const initialState = {}

export default function ProfileReducer(state = initialState, action) {
    switch (action.type) {
            case ActionTypes.SET_PROFILE_DATA:
        return { ...action.payload };

      case ActionTypes.SET_LOGOUT:
        return { }
  
      default:
        return state;
    }
  }